import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class EmissionMobilityPermissions extends BaseScenesPermissions {}

export default EmissionMobilityPermissions
